var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmTourIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 32.5H23.3337M17.7781 36.6667H22.2225",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3506 22.8008L14.1907 24.5327C14.707 25.0186 14.9997 25.6961 14.9997 26.405C14.9997 27.47 15.863 28.3333 16.928 28.3333H23.0714C24.1363 28.3333 24.9997 27.47 24.9997 26.405C24.9997 25.6961 25.2924 25.0186 25.8086 24.5327L27.6487 22.8008C30.2174 20.3645 31.6518 17.164 31.6662 13.8365L31.6663 13.6968C31.6663 8.01148 26.443 3.33331 19.9997 3.33331C13.5564 3.33331 8.33301 8.01148 8.33301 13.6968L8.33312 13.8365C8.34759 17.164 9.782 20.3645 12.3506 22.8008Z",
    stroke: "#DC143C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmTourIcon);
export default __webpack_public_path__ + "static/media/confirm-tour-icon.ae51f9ec04273e87e0702009e2c03682.svg";
export { ForwardRef as ReactComponent };